import { render, staticRenderFns } from "./ActivityWelfareLl.vue?vue&type=template&id=4f9d05ee"
import script from "./ActivityWelfareLl.vue?vue&type=script&lang=js"
export * from "./ActivityWelfareLl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports